// extracted by mini-css-extract-plugin
export default {"wrapper":"C3-z","play":"D3-z"};